import {
  GET_EVENTS_START,
  GET_EVENTS_ERROR,
  GET_EVENTS,
  LOAD_MORE_EVENTS_START,
  LOAD_MORE_EVENTS_ERROR,
  LOAD_MORE_EVENTS,
  EVENTS_CONSTANT_FILTERS_INIT,
  EVENTS_APPLY_FILTERS_START,
  EVENTS_APPLY_FILTERS_ERROR,
  EVENTS_APPLY_FILTERS_UPDATE,
  EVENTS_APPLY_FILTERS_RESET,
  EVENTS_APPLY_FILTERS_INIT,
  EVENTS_APPLY_FILTERS,
  ADDRESS_RESULTS,
  ADDRESS_SELECTED,
  GET_EVENTS_INIT,
  EVENT_SIGNUP_TOGGLE,
  EVENT_SIGNUP_SUBMITTED,
} from '../actions/events';

const initialState = {
  isLoadingData: true,
  isLoadingMoreEvents: false,
  isApplyingFilters: false,
  requestError: false,
  eventSignupToggle: false,
  eventSignupSubmitted: false,
  total: 0,
  pageSize: 0,
  pageStart: 0,
  noEvent: {},
  parentEvent: '',
  constantFilters: {},
  availableFilters: {
    topic: [],
    type: [],
  },
  appliedFilters: {
    topic: [],
    type: [],
    dateTo: '',
    dateFrom: '',
    latitude: '',
    longitude: '',
    radius: '',
  },
  address: {
    results: [],
    selected: {},
  },
  eventListing: [],
};

export const eventsReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case GET_EVENTS_INIT:
      return {
        ...state,
        isLoadingData: false,
        ...action.payload,
      };
    case GET_EVENTS_START:
      return {
        ...state,
        isLoadingData: true,
        requestError: false,
      };
    case GET_EVENTS_ERROR:
      return {
        ...state,
        data: null,
        isLoadingData: false,
        requestError: true,
      };
    case GET_EVENTS:
      return {
        ...state,
        isLoadingData: false,
        total: action.payload.total,
        pageSize: action.payload.pageSize,
        pageStart: action.payload.pageStart,
        availableFilters: action.payload.filters.availableFilters,
        appliedFilters: {
          ...state.appliedFilters,
          ...action.payload.filters.appliedFilters,
        },
        eventListing: action.payload.eventList,
      };
    case LOAD_MORE_EVENTS_START:
      return {
        ...state,
        isLoadingMoreEvents: true,
      };
    case LOAD_MORE_EVENTS_ERROR:
      return {
        ...state,
        isLoadingMoreEvents: false,
      };
    case LOAD_MORE_EVENTS:
      return {
        ...state,
        eventListing: [...state.eventListing, ...action.payload.eventList],
        isLoadingMoreEvents: false,
      };

    case EVENTS_CONSTANT_FILTERS_INIT:
      return {
        ...state,
        constantFilters: action.payload,
      };
    case EVENTS_APPLY_FILTERS_INIT:
      return {
        ...state,
        ...action.payload,
      };
    case EVENTS_APPLY_FILTERS_START:
      return {
        ...state,
        isApplyingFilters: true,
      };
    case EVENTS_APPLY_FILTERS_ERROR:
      return {
        ...state,
        isApplyingFilters: false,
      };
    case EVENTS_APPLY_FILTERS_UPDATE:
      return {
        ...state,
        appliedFilters: { ...state.appliedFilters, ...action.payload },
      };
    case EVENTS_APPLY_FILTERS:
      return {
        ...state,
        isApplyingFilters: false,
        total: action.payload.total,
        pageSize: action.payload.pageSize,
        pageStart: action.payload.pageStart,
        availableFilters: action.payload.filters.availableFilters,
        appliedFilters: {
          ...state.appliedFilters,
          ...action.payload.filters.appliedFilters,
        },
        eventListing: action.payload.eventList,
      };
    case EVENTS_APPLY_FILTERS_RESET:
      return {
        ...state,
        appliedFilters: {},
      };
    case ADDRESS_RESULTS:
      return {
        ...state,
        address: {
          ...state.address,
          results: action.payload,
        },
      };
    case ADDRESS_SELECTED:
      return {
        ...state,
        address: {
          ...state.address,
          selected: action.payload,
        },
      };
    case EVENT_SIGNUP_TOGGLE:
      return {
        ...state,
        eventSignupToggle: action.payload,
      };
    case EVENT_SIGNUP_SUBMITTED:
      return {
        ...state,
        eventSignupSubmitted: action.payload,
      };
    default:
      return state;
  }
};
